var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex h-100 overflow-auto flex-column" },
    [
      _setup.currentHeading
        ? _c(
            "header",
            {
              key: "header-" + _setup.proxy.$route.fullPath,
              staticClass: "d-flex align-items-center border-bottom",
            },
            [
              _c(
                "span",
                {
                  staticClass: "ms-2 flex-fill d-flex align-items-center small",
                },
                [
                  _c(
                    _setup.Button,
                    {
                      staticClass: "btn-sm lh-1 me-1 p-1",
                      nativeOn: {
                        click: function ($event) {
                          return _setup.goToListing.apply(null, arguments)
                        },
                      },
                    },
                    [_c("small", [_vm._v(_vm._s(_setup.component?.title))])]
                  ),
                  _vm._v(" "),
                  _c("i", { staticClass: "bi-chevron-compact-right" }),
                  _vm._v(" "),
                  _c("small", { staticClass: "px-2 d-inline-block" }, [
                    _vm._v(_vm._s(_setup.currentHeading)),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(_setup.ComponentEditorBtnGroup),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("router-view", {
        key: _setup.proxy.$route.params.component,
        staticClass: "overflow-auto",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }